// extracted by mini-css-extract-plugin
export default {"Button":"styledButton_Button__uQhEw","Loading":"styledButton_Loading__PdMFX","NoShadow":"styledButton_NoShadow__u8Y02"};